import { Text, View, Link } from '@react-pdf/renderer';
import styles from '../styles/styles';

interface Species {
  abr: string;
  lat: string;
}

interface OverviewProps {
  labels: {
    header: string;
    stackNumber: string;
    assortment: string;
    species: string;
    effectiveLength?: string;
    depth?: string;
    avgDiameter?: string;
    volumeRm?: string;
    volumeM3?: string;
    volumeProduced?: string;
    weightTon?: string;
    map: string;
    gps: string;
    nearestAddress: string;
    origin: string;
    link: { label: string; href: string };
    quality?: string;
    measMethod?: string;
    longestLog?: string;
    shortestLog?: string;
    avgLength?: string;
    avgVol?: string;
  };
  data: {
    stackNumber: string;
    assortment: string;
    species: Species[];
    effectiveLength?: string;
    depth?: string;
    avgDiameter?: string;
    volumeRm?: string;
    volumeM3?: string;
    volumeProduced?: string;
    weightTon?: string;
    gpsCoordinates: { lat: number; long: number };
    nearestAddress?: string;
    origin: string;
    quality?: string;
    measMethod?: string;
    longestLog?: string;
    shortestLog?: string;
    avgLength?: string;
    avgVol?: string;
  };
}


const Overview = ({ labels, data }: OverviewProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    <View style={styles.miniSpacer} />

    <View style={styles.row}>
      {/* Col 1 */}
      <View style={styles.column}>
        <View>
          <Text style={styles.label}>{labels.stackNumber}:</Text>
          <Text>{data.stackNumber}</Text>
        </View>

        <View style={styles.miniSpacer} />
        <Text style={styles.label}>{labels.assortment}:</Text>
        <Text>{data.assortment}</Text>

        <View style={styles.miniSpacer} />
        <Text style={styles.label}>{labels.species}:</Text>
        <Text>{data.species.map(s => `${s.abr} ${s.lat}`).join(', ')}</Text>

        {labels.quality && data.quality && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.quality}:</Text>
            <Text>{data.quality}</Text>
          </>
        )}

        {labels.measMethod && data.measMethod && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.measMethod}:</Text>
            <Text>{data.measMethod}</Text>
          </>
        )}
      </View>

      {/* Col 2 */}
      <View style={styles.column}>
        {labels.effectiveLength && data.effectiveLength && (
          <View>
            <Text style={styles.label}>{labels.effectiveLength}:</Text>
            <Text>{data.effectiveLength}</Text>
          </View>
        )}

        {labels.depth && data.depth && (
          <View>
            <Text style={styles.label}>{labels.depth}:</Text>
            <Text>{data.depth}</Text>
          </View>
        )}

        {labels.avgDiameter && data.avgDiameter && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.avgDiameter}:</Text>
            <Text>{data.avgDiameter}</Text>
          </>
        )}

        {/* Logs only */}
        {labels.longestLog && data.longestLog && (
          <>
            <Text style={styles.label}>{labels.longestLog}:</Text>
            <Text>{data.longestLog}</Text>
          </>
        )}

        {labels.shortestLog && data.shortestLog && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.shortestLog}:</Text>
            <Text>{data.shortestLog}</Text>
          </>
        )}

        {labels.avgLength && data.avgLength && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.avgLength}:</Text>
            <Text>{data.avgLength}</Text>
          </>
        )}
      </View>

      {/* Col 3 */}
      <View style={styles.column}>
        {labels.volumeM3 && data.volumeM3 && (
          <>
            <Text style={styles.label}>{labels.volumeM3}:</Text>
            <Text>{data.volumeM3}</Text>
          </>
        )}

        {labels.volumeRm && data.volumeRm && (
          <View>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.volumeRm}:</Text>
            <Text>{data.volumeRm}</Text>
          </View>
        )}

        {labels.volumeProduced && data.volumeProduced && (
          <View>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.volumeProduced}</Text>
            <Text>{data.volumeProduced}</Text>
          </View>
        )}

        {labels.weightTon && data.weightTon && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.weightTon}:</Text>
            <Text>{data.weightTon}</Text>
          </>
        )}

        {labels.avgVol && data.avgVol && (
          <>
            <View style={styles.miniSpacer} />
            <Text style={styles.label}>{labels.avgVol}:</Text>
            <Text>{data.avgVol}</Text>
          </>
        )}
      </View>

      {/* Col 4 */}
      <View style={styles.column}>
        <View>
          <Text style={styles.label}>{labels.map}:</Text>
          <Link src={labels.link.href}>{labels.link.label}</Link>
          <View style={styles.miniSpacer} />
        </View>

        <View>
          <Text style={styles.label}>{labels.gps}:</Text>
          <Text>{data.gpsCoordinates.lat}, {data.gpsCoordinates.long}</Text>
          <View style={styles.miniSpacer} />
        </View>

        <View>
          <Text style={styles.label}>{labels.nearestAddress}:</Text>
          <Text>{data.nearestAddress || "-"}</Text>
          <View style={styles.miniSpacer} />
        </View>

        <View>
          <Text style={styles.label}>{labels.origin}:</Text>
          <Text>{data.origin}</Text>
        </View>
      </View>
    </View>
  </>
);

export default Overview;
